import { useState } from "react";

import CodeViewer from "@/components/CodeViewer";

// `onCopy` fires only after the command really reached the clipboard — callers use it for
// analytics, so it must not run when the write throws.
export default function CopyCommand({ command, onCopy }: { command: string; onCopy?: () => void }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
      // Last, and after the tick is shown: this catch swallows errors, so a caller's callback
      // must not be able to cost the user their "Copied" feedback.
      onCopy?.();
    } catch {
      /* clipboard unavailable */
    }
  }

  return (
    <div className="flex items-stretch gap-2">
      {/* Shiki-highlighted (bash), theme-aware — same code panel as the file viewer. */}
      <div className="min-w-0 flex-1">
        <CodeViewer code={command} lang="bash" />
      </div>
      <button
        onClick={copy}
        aria-label={copied ? "Copied" : "Copy command"}
        title={copied ? "Copied" : "Copy"}
        className="flex shrink-0 items-center justify-center rounded-lg border border-white/10 bg-white/5 px-3 text-text/70 transition hover:border-primary hover:text-text"
      >
        {copied ? (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="text-green-400">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        )}
      </button>
    </div>
  );
}
